module.exports = __webpack_public_path__ + "static/media/section05_04.eae6ae91.jpg";